module.exports = __webpack_public_path__ + "img/logo_light_gray.06e951a7.svg";